/**
 * Loading component for VulForm
 */

import React from 'react';

interface FormLoaderProps {
  loadingState?: 'default' | 'custom' | React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const FormLoader: React.FC<FormLoaderProps> = ({
  loadingState = 'default',
  className = '',
  style,
}) => {
  if (typeof loadingState === 'object' && React.isValidElement(loadingState)) {
    return (
      <div className={className} style={style}>
        {loadingState}
      </div>
    );
  }

  if (loadingState === 'custom') {
    return (
      <div className={`vulform-loading ${className}`} style={style}>
        <div className='animate-pulse space-y-4'>
          <div className='h-4 bg-gray-300 rounded w-3/4'></div>
          <div className='h-10 bg-gray-300 rounded'></div>
          <div className='h-4 bg-gray-300 rounded w-1/2'></div>
          <div className='h-10 bg-gray-300 rounded'></div>
          <div className='h-10 bg-gray-300 rounded w-1/3'></div>
        </div>
      </div>
    );
  }

  return (
    <div className={`vulform-loading ${className}`} style={style}>
      <div className='flex items-center justify-center p-4 sm:p-6'>
        <div className='flex items-center space-x-2 sm:space-x-3'>
          <div className='animate-spin rounded-full h-5 w-5 sm:h-6 sm:w-6 border-b-2 border-blue-600'></div>
          <span className='text-gray-600 font-medium text-sm sm:text-base'>Loading form...</span>
        </div>
      </div>
    </div>
  );
};

export default FormLoader;
